<template>
    <section class=" font-poppins">
        <div>
            <TheHeader/>
        </div>

        <div class=" w-1/2 m-auto text-center pt-40 md:w-4/5 mb-16 ">
            <div class=" w-1/2 m-auto mt-8">
                <img src="./Images/Bookeh.png" alt="">
            </div>

            <div class=" font-semibold text-xl mt-14 leading-10">
                <p>
                    You have successfully completed your registration. An email will be sent to you 
                    containing details for physical verification.
                </p>
            </div>
        </div>

        <div>
            <TheFooter/>
        </div>
    </section>
</template>

<script>
import TheFooter from '../layout/TheFooter.vue'
import TheHeader from '../layout/TheHeader.vue'
export default {
  components: { TheHeader, TheFooter },
    
}
</script>